// extracted by mini-css-extract-plugin
export var errorIcon = "_l2-1";
export var nameLogo = "_l2-0";